import { render, staticRenderFns } from "./sortButton.vue?vue&type=template&id=4ef46671"
import script from "./sortButton.vue?vue&type=script&lang=js"
export * from "./sortButton.vue?vue&type=script&lang=js"
import style0 from "./sortButton.vue?vue&type=style&index=0&id=4ef46671&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports